<div class="subscription-container">
  <app-add-product-button
    buttonText="Legg til nytt abonnement"
    class="add-subscription-button"
    testId="add-new-voice-subscription-button"
    [iconName]="IconNames.ice_simcard"
    [isDisabled]="isLoadingProducts() || (hasPerformedAllowanceCheck() && !allowanceCheckSuccessful())"
    (add)="onAddVoiceProduct()"
  />

  @if (allowanceCheckSuccessful()) {
    <div class="num-subscriptions-allowed">
      {{ (products$ | async).length }}/{{ numberOfSubscriptionAllowed() }} abonnementer
    </div>
  } @else {
    <div class="missing-creditcheck-alert">
      <app-ice-card type="neutral">
        <div class="missing-customer-message">
          <span class="alert-label">Mangler kunde.</span>
          Det er mulig at abonnementer må fjernes etter gjennomført kredittsjekk.
        </div>
      </app-ice-card>
    </div>
  }

  @if (products.length === 0) {
    <app-ice-card type="neutral">
      <div class="no-products-container">Nye avtaler vil dukke opp her.</div>
    </app-ice-card>
  }

  @if (form) {
    <form ngxsForm="formState.subscriptionForm" [formGroup]="form">
      <app-accordion class="accordions">
        @for (item of list; track $index; let i = $index) {
          <app-accordion-group formArrayName="list">
            <app-accordion-header
              testId="subscription-accordion-button"
              [disabled]="products[i]?.isExistingSubscription"
              [icon]="IconNames.ice_simcard"
              [isOpen]="selectedSubscriptionId() === products[i]?.id"
              [message]="
                !item.status || item.status === FormStatus.PENDING
                  ? ''
                  : (item.valid || (item.statusChanges | async) === FormStatus.VALID) &&
                      item.controls.interactedSteps?.value?.length > 0
                    ? 'Ferdig registrert'
                    : 'Ikke ferdig registrert'
              "
              [messageType]="
                (item.valid || (item.statusChanges | async) === FormStatus.VALID) &&
                item.controls.interactedSteps?.value?.length > 0
                  ? MessageType.success
                  : selectedSubscriptionId() === products[i]?.id
                    ? MessageType.neutral
                    : MessageType.error
              "
              [showMenu]="true"
              (toggleAccordion)="onToggleAccordion(products[i], item)"
            >
              <span class="subscription-header-title">
                {{ getSubscriptionName(products[i]) }}
              </span>
              <div menu-content>
                <button data-testid="remove-voice-product-button" mat-menu-item (click)="onRemoveVoiceProduct(products[i])">
                  <span>Slett</span>
                </button>
              </div>
            </app-accordion-header>
            <app-accordion-content [isOpen]="selectedSubscriptionId() === products[i]?.id">
              <ng-template appAccordionLazy>
                <div class="subscription-content-container">
                  <div [formGroup]="item">
                    <app-subscription-stepper
                      [canSellMobilePhone]="canSellMobilePhone()"
                      [isEquipmentUpgradeEnabled]="isEquipmentUpgradeEnabled()"
                      [product]="products[i]"
                      (finishSubscription)="onFinishSubscription(products[i], item)"
                    />
                  </div>
                </div>
              </ng-template>
            </app-accordion-content>
          </app-accordion-group>
        }
      </app-accordion>
    </form>
  }

  <div class="existing-subscriptions-title">Kundens abonnementer</div>

  @for (inFlightVoiceOrder of inFlightVoiceOrders(); track inFlightVoiceOrder.orderId) {
    <div>
      <app-customer-agreement
        iconName="ice_simcard"
        [isInFlightOrder]="true"
        [mainHeading]="inFlightVoiceOrder.aNumber"
        [subHeading]="inFlightVoiceOrder.description"
      >
        <app-ice-badge type="neutral">Under behandling</app-ice-badge>
      </app-customer-agreement>
    </div>
  }

  @for (inFlightServiceOrder of inFlightServicesOrders(); track inFlightServiceOrder.orderId) {
    <div>
      <app-customer-agreement
        iconName="ice_simcard"
        [isInFlightOrder]="true"
        [mainHeading]="
          inFlightServiceOrder.orderItemType === InFlightOrderItemTypes.AddSlaveSim
            ? inFlightServiceOrder.icc
              ? 'Data/Tvilling-SIM: ' + inFlightServiceOrder.icc
              : 'Data/Tvilling-SIM'
            : inFlightServiceOrder.description
        "
      >
        <app-ice-badge type="neutral">Under behandling</app-ice-badge>
      </app-customer-agreement>
    </div>
  }

  @if (isLoadingProducts() || isLoadingExistingProductDetails()) {
    <app-spinner />
  } @else {
    @if (existingProducts.length === 0) {
      <app-ice-alert type="neutral" [iconName]="IconNames.ice_info">Ingen eksisterende abonnementer.</app-ice-alert>
    }
    <app-accordion class="accordions">
      @for (existingProduct of existingProducts | sortBy: 'subscriptionOffering.dataVolume'; track existingProduct.id) {
        <app-accordion-group data-testid="existing-subscription">
          <app-accordion-header
            testId="existing-subscription-accordion-button"
            [icon]="IconNames.ice_simcard"
            [isOpen]="selectedSubscriptionId() === existingProduct.id"
            [message]="hasVoiceSubscriptionChanged(existingProduct) ? 'Abonnement endret' : ''"
            [messageType]="hasVoiceSubscriptionChanged(existingProduct) ? MessageType.warning : MessageType.neutral"
            [showMenu]="true"
            (toggleAccordion)="onToggleAccordion(existingProduct)"
          >
            <div class="existing-subscription-header">
              <div class="existing-subscription-header-information">
                <div>
                  <span class="existing-subscription-title">
                    {{ existingProduct.subscription.msisdn }}
                  </span>
                  <span class="existing-subscription-name">
                    {{ getSubscriptionName(existingProduct) }}
                  </span>
                </div>
                <div class="existing-subscription-info-wrapper">
                  @if (SubscriptionHelperService.isSubscriptionFrozenOrSuspended(existingProduct.subscription)) {
                    <app-ice-badge class="existing-subscription-badge" type="info">
                      {{ SubscriptionStatusFrozenSuspendedText[existingProduct.subscription.status] }}
                    </app-ice-badge>
                  }
                  @if (VoiceProduct.isActivationInProgress(existingProduct)) {
                    <app-ice-badge class="existing-subscription-badge" type="info">
                      {{ existingProduct.subscription.isPortingNumber ? 'Overføres til Ice' : 'Aktiveres ' }}
                      {{ existingProduct.subscription?.activeSince | date: 'dd.MM.yyyy' }}
                    </app-ice-badge>
                  }
                  @if (SubscriptionHelperService.getFutureBindingExpirationDate(existingProduct); as expirationDate) {
                    <div class="existing-subscription-binding-information">
                      <span>Avtaletid til&nbsp;</span>
                      <span class="binding-period">{{ expirationDate | date: 'dd.MM.yyyy' }}</span>
                    </div>
                  } @else {
                    <div class="existing-subscription-no-binding">Ingen avtaletid</div>
                  }
                </div>
              </div>
              @if (existingProduct.offering?.monthlyPrice?.price || existingProduct.assignedSubscription?.monthlyCost) {
                <span class="header-price">
                  {{
                    existingProduct.offering?.id
                      ? existingProduct.offering?.monthlyPrice?.price?.includingVAT
                      : existingProduct.assignedSubscription?.monthlyCost?.includingVAT
                  }}
                  kr/mnd
                </span>
              }
            </div>
            <div menu-content>
              <button
                data-testid="open-voice-product-in-manny-button"
                mat-menu-item
                [disabled]="!existingProduct.subscription.customerId || !existingProduct.subscription.id"
                (click)="toManny(existingProduct)"
              >
                <span>Åpne i Manny</span>
              </button>
            </div>
          </app-accordion-header>
          <app-accordion-content [isOpen]="selectedSubscriptionId() === existingProduct.id">
            <ng-template appAccordionLazy>
              <app-existing-subscription [product]="existingProduct" />
            </ng-template>
          </app-accordion-content>
        </app-accordion-group>
      }
    </app-accordion>
  }
</div>
